import React from "react";
import "./PerioChart.css";

export default function PerioLegend() {
  return (
    <div className="perio-legend-container">

      {/* SECTION 1: POCKET DEPTHS */}
      <div className="legend-group">
        <span className="legend-label">Pocket Depth:</span>

        <div className="legend-chip chip-healthy">
          <span className="color-box pd-healthy" />
          1–3 mm
        </div>

        <div className="legend-chip chip-moderate">
          <span className="color-box pd-moderate" />
          4–5 mm (⚠ Warning)
        </div>

        <div className="legend-chip chip-deep">
          <span className="color-box pd-deep" />
          ≥ 6 mm (🔴 Danger)
        </div>
      </div>

      <div className="legend-divider" />

      {/* SECTION 2: MOBILITY */}
      <div className="legend-group">
        <span className="legend-label">Mobility:</span>

        <div className="legend-text">
          <strong>0</strong> <span className="sub">Normal</span>
        </div>
        <div className="legend-text">
          <strong>I</strong> <span className="sub">0.2–1 mm</span>
        </div>
        <div className="legend-text">
          <strong>II</strong> <span className="sub">&gt;1 mm</span>
        </div>
        <div className="legend-text">
          <strong>III</strong> <span className="sub">Vertical</span>
        </div>
      </div>

      <div className="legend-divider" />

      {/* SECTION 3: SITES */}
      <div className="legend-group">
        <span className="legend-label">Sites:</span>
        <div className="legend-text"><strong>MB</strong> <span className="sub">Mesio-Buccal</span></div>
        <div className="legend-text"><strong>B</strong> <span className="sub">Buccal</span></div>
        <div className="legend-text"><strong>DB</strong> <span className="sub">Disto-Buccal</span></div>
        <div className="legend-text"><strong>DL</strong> <span className="sub">Disto-Lingual</span></div>
        <div className="legend-text"><strong>L</strong> <span className="sub">Lingual</span></div>
        <div className="legend-text"><strong>ML</strong> <span className="sub">Mesio-Lingual</span></div>
      </div>

    </div>
  );
}
